import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store';
import { logout } from 'store/slices/auth';

import { Button } from '../button';

import { LogoutButtonProps } from './types';

export const LogoutButton = ({ className }: LogoutButtonProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['header']);

  return (
    <Button
      color="secondary"
      className={className}
      onClick={() => dispatch(logout({ byUser: true }))}
    >
      {t('logOut')}
    </Button>
  );
};
